import React from 'react';
import Modal from '../../../../UiKit/Modal/Modal';
import NavigationButton, { NavigationButtonGroup } from '../../../../UiKit/Wizard/NavigationButton/NavigationButton';
import Body from "../../../../UiKit/Wizard/Body/Body";
import './PrivacyStatementModal.css'; 
import translations from '../translation';
import { useLanguage } from '../../../../UiKit/Wizard/langugeContext';

function PrivacyStatementModal({ type, insideWizard, handleClose }) {
  const { currentLanguage } = useLanguage();
  const privacyTranslations = translations[currentLanguage]["privacyStatementModal"] || {};
  return (

    <Modal type={type} insideWizard={false} className="privacy-modal-overlay">
 <Modal.Dialog className="modal__dialog privacy-modal-dialog">
      <Modal.Header>
        <Modal.Close onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Modal.Title>{privacyTranslations.privacyStatement}</Modal.Title>
        <Modal.Content>
          <Body
            bodyText={
              <div style={{ fontSize: "12px", lineHeight: "16px" }}>
               {privacyTranslations.privacyStatementText}
              </div>
            }
          />
        </Modal.Content>
        <NavigationButtonGroup>
          <NavigationButton type="primary" onClick={handleClose}>
            Close
          </NavigationButton>
        </NavigationButtonGroup>
      </Modal.Body>
    </Modal.Dialog>
  </Modal>
  
  );
}

export default PrivacyStatementModal;
